<app-header></app-header>

<!--================== Breadcumb ========== -->
<div class="breadcumb-wrapper " data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Latest News</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Our Blog</li>
            </ul>
        </div>
    </div>
</div>
<!--======= Blog Area ============-->
<section class="th-blog-wrapper space-top space-extra-bottom">
    <div class="container">
        <div class="row" *ngIf="blogs && blogs.length > 0">
            <div class="col-xxl-8 col-lg-7">

                <div *ngFor="let blog of blogs" class="th-blog blog-single has-post-thumbnail">
                    <div class="blog-img">
                        <a routerLink="/latest-news/{{ blog.slug }}">
                            <img class="blog-lg-feature-img" [src]="blog.featured_image" (error)="onImageError($event)"
                                alt="{{ blog.title }}" />
                        </a>
                    </div>
                    <div class="blog-content">
                        <div class="blog-meta">
                            <a class="author" routerLink="/latest-news">
                                <i class="fa-light fa-user"></i>by Team Xipetech
                            </a>
                            <a routerLink="/latest-news">
                                <i class="fa-regular fa-calendar"></i>{{ blog.published_at | date:'dd MMMM yyyy' }}
                            </a>
                        </div>
                        <h2 class="blog-title">
                            <a routerLink="/latest-news/{{ blog.slug }}" [innerHTML]="blog.title">{{ blog.title ?? ''
                                }}</a>
                        </h2>
                        <p class="blog-text" [innerHTML]="blog.excerpt">{{ blog.excerpt ?? '' }}</p>

                        <a routerLink="/latest-news/{{ blog.slug }}" class="th-btn style4 th-icon">
                            Read More <i class="fa-light fa-arrow-right-long"></i>
                        </a>
                    </div>
                </div>

                <div class="th-pagination mt-60" *ngIf="meta?.links?.length > 0">
                    <ul>
                        <li *ngFor="let link of meta.links; let i = index">
                            <ng-container *ngIf="i !== 0"> <!-- Skip first "Previous" -->
                                <a [class.active]="link.active" [class.next-page]="i === meta.links.length - 1"
                                    href="javascript:void(0)" (click)="link.page ? loadBlogs(link.page, 5) : null">

                                    <ng-container *ngIf="i === meta.links.length - 1; else normalLabel">
                                        <i class="fa-sharp fa-light fa-arrow-right"></i>
                                    </ng-container>

                                    <ng-template #normalLabel>{{ link.label }}</ng-template>
                                </a>
                            </ng-container>
                        </li>
                    </ul>
                </div>

            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-blog-sidebar></app-blog-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>